import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { whatsappUrl } from "@/lib/whatsapp";

const WhatsAppButton = () => {
  const { t } = useLanguage();

  return (
    <motion.a
      data-testid="whatsapp-floating-btn"
      href={whatsappUrl(t.whatsapp.message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsapp.aria}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      className="group fixed bottom-6 right-6 z-[80] flex items-center gap-3"
    >
      <span className="pointer-events-none translate-x-2 rounded-full border border-em/30 bg-panel/90 px-4 py-2 font-mono text-xs text-em opacity-0 backdrop-blur-md transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100">
        {t.whatsapp.label}
      </span>
      <span className="relative grid h-14 w-14 place-items-center rounded-full bg-em shadow-[0_0_30px_rgba(0,229,163,0.35)]">
        <span className="absolute inset-0 animate-pulse-ring rounded-full border-2 border-em" />
        <MessageCircle className="h-6 w-6 text-ink" />
      </span>
    </motion.a>
  );
};

export default WhatsAppButton;
